export * from './link';
export { createOperation, makePromise, toPromise, fromPromise, fromError, } from './linkUtils';
import Observable from 'zen-observable-ts';
export { Observable };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-link/lib/index.js
// module id = 44
// module chunks = 0